import React from 'react'
import FlexView from 'react-flexview/lib'
import { Equipment } from '../../../models/hull-models/Equipment'
import { SkyPaper } from '../Frames/SkyPaper'
import { getSvg } from './EquipmentView'
import { FirebaseService, FirebaseConfigKey } from '../../../services/FirebaseService'
import { BrowserView, MobileView } from 'react-device-detect'

interface PolicyEquipmentViewProps {
    equipment: Equipment
}

export const PolicyEquipmentView = ({equipment, equipmentPremium, equipmentDeductible, ...props}: PolicyEquipmentViewProps) => {
    return (
        <FlexView >
            <FlexView vAlignContent={'top'}>
                <SkyPaper small>
                    {getSvg(equipment.type)}
                </SkyPaper>
            </FlexView>
            {FirebaseService.getBoolean(FirebaseConfigKey.SHOW_HULL_PREMIUMS_ON_POLICY_PAGE) &&
                <FlexView className="margin-left-basic" column={true}>
                    <div >
                    <div className="black bold text-small">{equipment.quantity + 'x - ' + equipment.type}</div>
                    <div className="gray text-tiny margin-top-3">{ equipment.description + (equipment.serial? ' ' + equipment.serial : '')}</div>
                    {FirebaseService.getBoolean(FirebaseConfigKey.SHOW_HULL_PREMIUMS_ON_POLICY_PAGE) &&
                        <MobileView>
                            {equipmentPremium > 0 && <div className="lightgrayblue text-tiny">
                                Premium: {FirebaseService.getValue(FirebaseConfigKey.CURRENCY_SYMBOL)}{equipmentPremium.toLocaleStringToFixed()} 
                                {equipmentDeductible > 0 && <span> | Deductible: {FirebaseService.getValue(FirebaseConfigKey.CURRENCY_SYMBOL)}{equipmentDeductible.toLocaleStringToFixed()}</span>}
                            </div>}
                        </MobileView>
                    }
                </div>
                    {equipmentPremium > 0 && <FlexView column vAlignContent={'center'} className="margin-top-3 full-height">
                        <div className="gray text-tiny">Premium: {FirebaseService.getValue(FirebaseConfigKey.CURRENCY_SYMBOL)}{equipmentPremium.toLocaleStringToFixed()}</div>
                        {equipmentDeductible > 0 && <div className="gray text-tiny margin-top-3">Deductible: {FirebaseService.getValue(FirebaseConfigKey.CURRENCY_SYMBOL)}{equipmentDeductible.toLocaleStringToFixed()}</div>}
                    </FlexView>}
                </FlexView>
            }
        </FlexView>
    )
}